/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
import { Box, Typography } from "@mui/material";
import React, { FC } from "react";
import { contentFooterStyle, contentPageInnerStyle } from "./ContentPage.style";

import { ITermItemResponse } from "../../services/terms/terms.interface";

interface IContentPageProps {
  content: ITermItemResponse
}

const PrivacyContentPage: FC<IContentPageProps> = ({ content }) => {
  return (
    <>
      <Box sx={contentPageInnerStyle}>
        <Typography variant="h1"><b className="font-semibold">PRIVACY POLICY &amp; COOKIE POLICY</b></Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold">PRIVACY POLICY</b></Typography>
        <Typography><br/></Typography>
        <Typography>Last Updated: July 5, 2023
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">This Privacy Policy (<b className="font-semibold">{"\"Policy\""}</b>) applies to the website located at www.GoodVets.com,
        www.Good-Vets.com, and <a href="www.web.Goodvets.com"
          className="font-medium cursor-pointer">www.web.Goodvets.com</a> (collectively, the
        <b className="font-semibold">{"\"Website\""}</b>), mobile applications (“App”), and related services (
        <b className="font-semibold">{"\"Services\""}</b>) we provide on the Website (collectively, the terms Website, App and
        Services means the <b className="font-semibold">{"\"Site\""}</b>). The terms <b className="font-semibold">{"\"GoodVets\""}</b> and
        <b className="font-semibold">{"\"we\""}</b> refers to GoodVets Veterinary Services LLC., and its affiliates. This Policy
        describes the types of information we may collect from you or that you may provide to us when you visit or use
        our Site and our practices for collecting, using, maintaining, protecting, and disclosing that information.
        PLEASE READ THIS POLICY carefully to understand our policies and practices regarding your information and how we
        will treat it. If you do not agree with the provisions of this Policy, please do not use our Site. By accessing
        or using this Site, you agree to the terms of this Policy.</Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold">CHILDREN</b></Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">Our Site is not intended for children under 18 years of age. No one under the age of 18 may provide any personal
        information on the Site. We do not knowingly collect personal information from children under 18. If you are
        under 18, do not use or provide any information on this Site. If we learn we have collected or received personal
        information from a child under 18 without verification of parental consent, we will delete that information. If
        you believe we might have any information from or about a child under 18, please Contact Us.</Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold">INFORMATION WE COLLECT ABOUT YOU AND HOW WE COLLECT IT</b></Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">1. Personal Information</Typography>
        <Typography className="mb-2 font-16">
        We collect personal information that you provide us which identifies you, whether directly or indirectly, such
        as your name, address, email address, phone number, or any other identifier by which you may be contacted online
        or offline (<b className="font-semibold">{"\"personal information\""}</b>).
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">2. Pet Information</Typography>
        <Typography className="font-16">We may also collect information about your pet, such as your pet's name, species, breed, sex, birthday and
        treatment information. We respect the veterinarian-client-patient relationship; however the information
        collected on the Site, is not covered under such regulations, unless you have established a
        veterinarian-client-patient-relationship (<b className="font-semibold">{"\"Veterinarian-Client Relationship\""}</b>) is
        defined by the American Veterinary Medical Association. We do not intend to form a Veterinarian-Client
        Relationships with users of the Site or Services until your pet has had its first exam at one of our Clinics.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2">
        </Typography>
        <Typography className="mb-2 font-semibold font-16">3. Account and Profile Information
        </Typography>
        <Typography className="font-16">We collect information about you when you register for an account, create or modify your profile, set
        preferences, and sign-up for our Site.</Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2">
        </Typography>
        <Typography className="mb-2 font-semibold font-16">4. Content You Provide Us
        </Typography>
        <Typography className="font-16">We collect and store content that you post, send, receive, and share. This content includes any information about
        you that you may choose to disclose to us. Such content also includes the files and links you upload to our
        Site. We collect other content that you submit to our Site, which include social media or social networking
        websites operated by us. For example, you provide content to us when you participate in any interactive
        features, surveys, contests, promotions, activities or events.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">5. Information You Provide to Our Clinicians and Customer Support
        </Typography>
        <Typography className="font-16">We may also collect information from you when you provide certain information relating to our Site or Services to
        our customer support team or our community of licensed veterinarians, registered veterinary technicians and
        support staff (<b className="font-semibold">{"\"Clinicians\""}</b>) through the Site. through the Site. For example, you
        may provide information regarding a technical problem you are experiencing using our Site.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">6. Payment Information
        </Typography>
        <Typography className="font-16">We collect certain payment and billing information when you register to use our Site. Payment information is
        processed by our third-party payment processor, in accordance with its privacy policy and terms of service.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">7. Information Directly from You
        </Typography>
        <Typography className="font-16">With your prior consent, we collect your information on or through our Site.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-semibold font-16">This may include:</Typography>
        <ul className="pl-5 my-2 list-disc">
          <li>
            <Typography className="font-16">Information that you provide by filling in forms on our Site. This includes information provided at the
                time of registering to use our Site, participating in our Services, posting material, or requesting
                further Services. We may also ask you for information when you enter a contest or promotion sponsored by
                us, and when you report a problem with our Site.
            </Typography>
          </li>
          <li>
            <Typography className="font-16">Records and copies of your correspondence (including email addresses), if you contact us.
            </Typography>
          </li>
          <li>
            <Typography className="font-16">Your responses to surveys that we might ask you to complete for research purposes.
            </Typography>
          </li>
          <li>
            <Typography className="font-16">Details of transactions you carry out through our Site and of the fulfillment of our Services. You may be
                required to provide financial information before you utilize our Services.
            </Typography>
          </li>
          <li>
            <Typography className="font-16">Your search queries on the Site.
            </Typography>
          </li>
        </ul>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">8. Your Posted Information
        </Typography>
        <Typography className="font-16">You also may provide information to be published or displayed (hereinafter, <b
          className="font-semibold">{"\"posted\""}</b>) on public areas of the Site, or transmitted to other users of the Site or
        third parties (collectively, <b className="font-semibold">{"\"User Contributions\""}</b>). Your User Contributions are
        posted on and transmitted to others at your own risk. Although we limit access to certain pages/you may set
        certain privacy settings for such information by logging into your account profile, please be aware that no
        security measures are perfect or impenetrable. Additionally, we cannot control the actions of other users of the
        Site with whom you may choose to share your User Contributions. Therefore, we cannot and do not guarantee that
        your User Contributions will not be viewed by unauthorized persons.</Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">9. Information We Collect Through Automatic Data Collection Technologies.</Typography>
        <ul className="pl-5 my-2 list-disc">
          <li>
            <Typography className="mb-2 font-16">
                Information We Collect Automatically
                As is true of most other websites and mobile applications, our Site collects certain information
                automatically and stores it in log files. The information may include internet protocol (IP) addresses,
                the region or general location where your computer or device is accessing the internet, browser type,
                operating system and other usage information about the use of our Site, including a history of the pages
                you visit.</Typography>
          </li>
        </ul>
        <Typography><br/></Typography>
        <ul className="pl-5 my-2 list-disc">
          <li>
            <Typography className="font-16">Through Cookies and Other Similar Technologies
                "Cookies" include commonly used pieces of information in the form of small files that are placed on an
                individual's device to enable the individual to more easily communicate and interact with the Sites.
                When you visit our Site, we may send one or more cookies to your device. They enable us to store
                information about your device which helps us, amongst other things, to provide you with a good
                experience when you browse our Site and enhance the level of Services and functions provided. We also
                use third parties to send you advertisements on our other Sites that may be of interest to you, based on
                information collected about your use of our Site and other websites. To do so, these companies may place
                or recognize a unique cookie or similar on your browser. Please review our <a
              href="https://goodvets.com/privacy#cookies" className="font-medium cursor-pointer">Cookie Policy</a> for
                more information.</Typography>
          </li>
        </ul>
        <Typography><br/></Typography>
        <ul className="pl-5 my-2 list-disc">
          <li>
            <Typography className="font-16">Device and Connection Information
                We collect information about your computer, phone, tablet, or other devices you use to access our Site.
                This device information includes your connection type and settings when you install, access, update, or
                use our Services. We also collect information through your device about your operating system, browser
                type, IP address, URLs of referring/exit pages, device identifiers, and crash data. We use your IP
                address and/or country preference in order to approximate your location to provide you with a better
                service experience. How much of this information we collect depends on the type and settings of the
                device you use to access the Services. Server and data center service administrators can disable
                collection of this information via the administrator settings or prevent this information from being
                shared with us by blocking transmission at the local network level.
            </Typography>
          </li>
        </ul>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">10. Other Services You Link to Your Account
        </Typography>
        <Typography className="font-16">We receive information about you when you or your administrator integrate or link a third-party service with our
        Services as follows. (i) you may also integrate our Services with other service providers you use, such as to
        allow you to access, store, share and edit certain content from a third-party through our Site. (ii) you may
        authorize our Services to access, display and store files from a third-party document-sharing service within the
        Services interface. (iii) you may authorize our Site to connect with a third-party calendaring service so that
        your appointments are available to you through the Site. The information we receive when you link or integrate
        our Site with a third-party service depends on the settings, permissions and privacy policy controlled by that
        third-party service. You should always check the privacy settings and notices in these third-party services to
        understand what data may be disclosed to us or shared with our Site.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">11. Internet, Network, and Telecommunication</Typography>
        <Typography className="font-16">If you use our internet connection, networks, telecommunications systems or information processing systems, your
        activity and any files or messages on those systems may also be monitored by us at any time, in accordance with
        applicable law, for purposes of an investigation, or to ensure compliance with our company policies.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">12. Do Not Track</Typography>
        <Typography className="font-16">Our Site does not support Do Not Track settings ("DNT") at this time. DNT is a privacy preference you can set in
        your web browser to indicate that you do not want certain information about your website visits collected across
        websites when you have not interacted with that service on a page. Please review our <a
          href="https://goodvets.com/privacy#cookies" className="font-medium cursor-pointer">Cookie Policy</a> for
        information on how you can opt out of behavioral tracking on this website and how we respond to web browser
        signals and other mechanisms that enable consumers to exercise choice about behavioral tracking.
        </Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">HOW WE USE YOUR INFORMATION</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">We use information that we collect about you or that you provide to us, including any personal information:</Typography>
        <Typography className="mb-2">
        </Typography>
        <ul className="pl-5 my-2 list-disc">
          <li>
            <Typography className="font-16">To present our Site and its contents to you.</Typography>
          </li>
          <li>
            <Typography className="font-16">To provide you with information, products, or services that you request from us.</Typography>
          </li>
          <li>
            <Typography className="font-16">To schedule appointments.</Typography>
          </li>
          <li>
            <Typography className="font-16">To fulfill any other purpose for which you provide it.</Typography>
          </li>
          <li>
            <Typography className="font-16">To provide you with notices about your account, wellness plan subscriptions or the terms and conditions
                of our Site, including expiration and renewal notices.</Typography>
          </li>
          <li>
            <Typography className="font-16">To carry out our obligations and enforce our rights arising from any contracts entered into between you
                and us, including for billing and collection.</Typography>
          </li>
          <li>
            <Typography className="font-16">To notify you about changes to our Site or any products or services we offer or provide though it.</Typography>
          </li>
          <li>
            <Typography className="font-16">To allow you to participate in interactive features on our Site.</Typography>
          </li>
          <li>
            <Typography className="font-16">To enable us to display marketing and advertisements to you.</Typography>
          </li>
          <li>
            <Typography className="font-16">In any other way we may describe when you provide the information. For any other purpose with your
                consent.
            </Typography>
          </li>
        </ul>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">HOW WE SHARE INFORMATION WITH OTHERS</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-16">1. In General
        </Typography>
        <Typography className="font-16">We do not rent, sell, or share your personal information about with other people or non affiliated companies for
        their direct marketing purposes, except as specifically described in this Privacy Policy. We use third party
        service providers to perform certain functions or services on our behalf. When we transfer your information, we
        require all our service providers to maintain the privacy, confidentiality and security of the personal
        information and data. We take steps to ensure that these third parties take protecting your privacy as seriously
        as we do.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">2. Types of Service Providers
        </Typography>
        <Typography className="font-16">We engage third parties to perform services on our behalf such as software maintenance services, hosting
        services, email service providers, database management, web analytics, payment processing and other services.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">3. Credit Card Processors
        </Typography>
        <Typography className="font-16">When you enter your credit card information, we transmit your information for processing using secure data
        transmission services (i.e., credit card information is encrypted). The third-party processor does not store any
        credit card data associated with any purchases processed on the website.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">4. Marketing Support Services
        </Typography>
        <Typography className="font-16">Like many companies, we contract with third parties to provide customer relationship management ("CRM") tools for
        marketing purposes. Typically, these CRM tools are available for our use through a cloud-based platform. We
        engage third parties to provide CRM tools that compile our customer personal information and data that may be
        collected through various channels, such as, through our Site, telephone, direct mail, and marketing materials.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">5. Law Enforcement and Internal Operations
        </Typography>
        <Typography className="font-16">Personal information may be provided where we are required to do so by law, or if we believe in good faith that
        it is reasonably necessary (i) to respond to claims asserted against us or to comply with the legal process (for
        example, discovery requests, subpoenas or warrants); (ii) to enforce or administer our policies and agreements
        with users; (iii) for fraud prevention, risk assessment, investigation, customer support, product development
        and debugging purposes; or (iv) to protect the rights, property or safety of GoodVets, its users or members of
        the general public. We will use commercially reasonable efforts to notify users about law enforcement or court
        ordered requests for data unless otherwise prohibited by law. However, nothing in this Privacy Policy is
        intended to limit any legal defenses or objections that you may have to any third-party request to compel
        disclosure of your information.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">6. Affiliates and Business Transfer
        </Typography>
        <Typography className="font-16">We may share your personal information with our parent, subsidiaries and affiliates. GoodVets may also sell,
        transfer or otherwise share some or all of its assets, including your personal information, in connection with a
        merger, acquisition, reorganization or sale of assets or in the event of bankruptcy. Under such circumstances,
        GoodVets will use commercially reasonable efforts to notify its users if their personal information is to be
        disclosed or transferred and/or becomes subject to a different privacy policy.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">7. Disclosure to Protect Others
        </Typography>
        <Typography className="font-16">If we believe disclosure is necessary or appropriate to protect the rights, property, or safety of GoodVets, our
        customers, or others. This includes exchanging information with other companies and organizations for the
        purposes of fraud protection and credit risk reduction.
        </Typography>
        <Typography><br/></Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold fomt-16">CHOICES ABOUT HOW WE USE AND DISCLOSE YOUR INFORMATION</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">We strive to provide you with choices regarding the personal information you provide to us. We have created
        mechanisms to provide you with the following control over your information:
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">1. Tracking Technologies and Advertising
        </Typography>
        <Typography className="font-16">You can set your browser to refuse all or some browser cookies, or to alert you when cookies are being sent. To
        learn how you can manage your Flash cookie settings, visit the Flash player settings page on Adobe's website. If
        you disable or refuse cookies, please note that some parts of this site may then be inaccessible or not function
        properly.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">2. Promotional Offers
        </Typography>
        <Typography className="font-16">If you do not wish to have your email address/contact information used by GoodVets to promote our own or third
        parties' products or services, you can opt-out by contacting us. If we have sent you a promotional email, you
        may send us a return email asking to be omitted from future email distributions. This opt out does not apply to
        information provided to the Company as a result of a product purchase, warranty registration, product service
        experience or other transactions.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-semibold font-16">3. Targeted Advertising
        </Typography>
        <Typography className="font-16">If you do not want us to use information that we collect or that you provide to us to deliver advertisements
        according to our advertisers' target-audience preferences, you can opt-out by contacting us. For this opt-out to
        function, you must have your browser set to accept all browser cookies.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">We do not control third parties' collection or use of your information to serve interest-based advertising.
        However these third parties may provide you with ways to choose not to have your information collected or used
        in this way. You can opt-out of receiving targeted ads from members of the Network Advertising Initiative
        ("NAI") on the NAI's website.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">Nevada residents who wish to exercise their sale opt-out rights under Nevada Revised Statutes Chapter 603A may
        submit a request to this designated address: support@goodvets.com. However, please know we do not currently sell
        data triggering that Statute's opt-out requirements.
        </Typography>
        <Typography><br/></Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">YOUR CHOICES</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-16">1. Accessing and Correcting or Deleting Your Information.</Typography>
        <ul className="pl-5 my-2 list-disc">
          <li>
            <Typography className="font-16">You can review and change your personal information via the Site through your account settings on the
                Site or by contacting us.</Typography>
          </li>
          <li>
            <Typography className="font-16">You may also send us an email at support@goodvets.com to request access to, correct or delete any
                personal information that you have provided to us. We cannot delete your personal information except by
                also deleting your user account. We may not accommodate a request to change information if we believe
                the change would violate any law or legal requirement or cause the information to be incorrect.</Typography>
          </li>
        </ul>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-16">2. Right to Review and Rectify Your personal information
        </Typography>
        <Typography className="font-16">You may access your account at any time to correct, update, or delete inaccuracies by logging into your account
        through the Site. If additional assistance is required to change or delete inaccuracies within your personal
        information or you would like to know what information about you was collected, please Contact Us. We reserve
        the right to charge for copies of data requested.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-16">3. Right to Remove or Withdraw Consent
        </Typography>
        <Typography className="font-16">You have the right to withdraw consent where such consent is required to share or use data, however, you will not
        be able to opt-out on via the Site. You may request that we delete your personal information. If you receive
        communications from us and no longer wish to receive them, please follow the opt-out or removal instructions in
        the email. To delete your account, you must make a request by contacting us. Since your personal information is
        required for us to provide the Services or to you, deleting it will also terminate your access to the Site and
        the Services. We may be required by law, to retain it to exercise or defend legal claims, or contractual
        obligations with our customers to retain some information in connection with your use of the Site and the
        Services. We may de-identify and anonymize some data for purposes of retaining it.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-16">4. Data Portability
        </Typography>
        <Typography className="font-16">If you would like us to transmit your personal information to another company providing similar services and we
        are required to so by law, we will work with them to do so upon request and verification of such request with
        both the requestor and the company receiving the personal information.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="mb-2 font-16">5. Communication
        </Typography>
        <Typography className="font-16">We will provide you reasonable mechanisms to exercise your choice regarding receipt of your personal information
        from GoodVets. When you receive an email from us, you may opt-out from receiving future emails from GoodVets by
        clicking on the unsubscribe link contained in the e-mail or by contacting us.
        </Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">DATA STORAGE AND RETENTION</b></Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">Your personal information is stored by GoodVets on its servers, and on the servers of the cloud-based database
        management services GoodVets engages, located in the United States. We will retain and use your personal
        information for as long as your account is active, as needed to provide you services, or as necessary to comply
        with our legal obligations, resolve disputes, and enforce our agreements.
        </Typography>
        <Typography className="font-16">For more information on where and how long your personal information is stored, and for more information on your
        rights of erasure and portability, please contact GoodVets's at support@goodvets.com.
        </Typography>
        <Typography><b className="font-semibold"><br/></b></Typography>
        <Typography><b className="font-semibold font-16">SECURITY</b>
        </Typography>
        <Typography><br/></Typography>
        <ul className="pl-5 my-2 list-disc">
          <li>
            <Typography className="font-16">Security of Your Information
                The security of your personal information is important to us. To help protect privacy and personal
                information you transmit through use of our Sites, we maintain physical, technical and administrative
                safeguards. All information you provide to us is stored on our secure servers behind firewalls. We take
                reasonable and appropriate measures to protect your personal information from loss, misuse and
                unauthorized access, disclosure, alteration and destruction by taking into due account the risks
                involved in the processing and the nature of the personal data. For example, we encrypt your credit card
                number when you provide such information to us for processing your orders.
            </Typography>
          </li>
          <li>
            <Typography className="font-16">
                Restrict Access to Your Information
                We restrict access to your personal information to those employees who need to know that information to
                provide benefits or services to you. In addition, we train our employees about the importance of
                confidentiality and maintaining the privacy and security of your information. However, because no
                security system can be 100% effective, we cannot completely guarantee the security of any information we
                store, process or transmit. We are not responsible for circumvention of any privacy settings or security
                measures contained on the Site.
            </Typography>
          </li>
        </ul>
        <Typography><br/></Typography>
        <Typography className="font-16">The safety and security of your information also depends on you. Any transmission of personal information is at
        your own risk. You are responsible for keeping the information you submit protected by preventing others from
        accessing your devices. We ask you not to share your password to your devices with anyone.
        </Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">Job Applicants</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">When you visit the Careers portion of the website, we collect the information that you provide to us in
        connection with your job application. This includes but is not limited to business and personal contact
        information, professional credentials and skills, educational and work history and other information of the type
        that may be included in a resume. This may also include diversity information that you voluntarily provide. We
        use this information on the basis of our legitimate business interests to facilitate our recruitment activities
        and process employment applications, such as by evaluating a job candidate for an employment activity, to
        monitor recruitment statistics and to respond to surveys. We may also use this information to provide improved
        administration of the services and as otherwise necessary (i) to comply with relevant laws or to respond to
        subpoenas or warrants served on us, (ii) to protect and defend our or others’ rights or property, (iii) in
        connection with a legal investigation and (iv) to investigate or assist in preventing any violation or potential
        violation of the law, this Privacy Policy or our Terms of Service.</Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">LINKS TO OTHER WEBSITES</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">This Site contains links to websites of other organizations. Unless otherwise specified, linkage to these other
        websites does not imply any relationship, sponsorship, or affiliation between GoodVets and these linked
        websites, nor does it imply any adoption or approval of the content of such websites. GoodVets does not have
        control over the policies or practices of these websites and is not responsible for their privacy practices or
        their content.
        </Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">DATA INTEGRITY</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">GoodVets will use your personal information only for the purposes for which it was collected, unless you provide
        prior consent. We will take reasonable steps to ensure that your personal information is relevant to its
        intended use, accurate, complete, and current.
        </Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">CHANGES TO OUR PRIVACY POLICY</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">It is our policy to post any changes we make to our privacy policy on this page. If we make material changes to
        how we treat our users' personal information, we will notify you by email to the email address specified in your
        account and/or through a notice on the Site. The date the Privacy Policy was last revised is identified at the
        top of the page. You are responsible for ensuring we have an up-to-date active and deliverable email address for
        you, and for periodically visiting our Site and this Policy to check for any changes.
        </Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">CONTACT US</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">To ask questions or comment about this privacy policy and our privacy practices, contact us
        at:support@goodvets.com.
        </Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">COOKIE POLICY</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">This Cookie Policy explains GoodVets Veterinary Services LLC and its affiliates (<b
          className="font-semibold">{"\"GoodVets\""}</b>) use cookies and similar technologies to recognize you when you visit
        our website at GoodVets.com and Good-Vets.com (the <b className="font-semibold">{"\"Site\""}</b>). It explains what these
        technologies are and why we use them, as well as your rights to control our use of them. For more information
        about your personal information, please see our Privacy Policy.
        </Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">WHAT IS A COOKIE?</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">A cookie is a small data file that is placed on your device when you visit a website. Cookies are widely used in
        order to make websites work or to work more efficiently, as well as to provide reporting information. A cookie
        may have unique identifiers and reside, among other places, on your device, in emails we send to you, and on the
        Site.
        </Typography>
        <Typography className="font-16">Cookies may be set by us or third-parties that perform services on our behalf. Cookies enable features or
        functionality in connection with our Site, for example, advertising, interactive content, and analytics. Cookies
        created by certain third-parties can recognize your device when you visit our Site and also when you visit
        certain other websites.
        </Typography>
        <Typography className="font-16">We may use other technologies similar to cookies like web beacons, which are sometimes called “tracking pixels”
        or “clear gifs”. These are tiny graphic files that contain a unique identifier that enable us to recognize when
        someone has visited our Site or opened an email that we have sent them. In many instances, these technologies
        are reliant on cookies to function properly, and so declining cookies will impair their functioning.
        </Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">WHY DO WE USE COOKIES?</b></Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">We Use Cookies for Several Reasons
        </Typography>
        <Typography className="font-16">Some are required for technical reasons in order for our Site to operate. Others provide a better experience on
        our Site by remembering some of your activities on the Site (including through our plug-ins, widgets, and
        embedded content). Other cookies enable more relevant advertising and better analytics.
        </Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">Essential Cookies</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">Some cookies are required to enable you to navigate throughout our Site. For example, to identify you as being
        logged into the Site or to make sure you connect to the right service on our Site when we make any changes to
        the way our Site works.</Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">Cookies for Analytics and Personalization</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">Some cookies collect information about how you use the Site to help us improve how our Site is being used, and to
        help us understand what may interest you and personalize your experience accordingly. These cookies, for
        example:
        </Typography>
        <ol className="pl-5 my-2 list-decimal">
          <li>
            <Typography className="font-16">Generate statistics on how the Site is used, including to measure any errors that occur or to obtain data
                on the number of users of the Site that have viewed a product
            </Typography>
          </li>
          <li>
            <Typography className="font-16">Test different designs for the Site
            </Typography>
          </li>
          <li>
            <Typography className="font-16">Help us track email response rates, identify when our emails are viewed, and track whether our emails are
                forwarded
            </Typography>
          </li>
          <li>
            <Typography className="font-16">Collect or transmit information about you, such as your browser type and search preferences, and your use
                of the Site or third-party sites that incorporate part of the Site</Typography>
          </li>
        </ol>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">Advertising Cookies</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">We and third parties use cookies to make advertising more relevant to you. They perform functions like measuring
        the performance of ads, preventing the same ad from continuously reappearing, ensuring that ads are properly
        displayed, and in some cases selecting ads that are based on your visits to our Site and other sites.
        </Typography>
        <Typography className="font-16 font-semibold">These cookies, for example:</Typography>
        <ol className="pl-5 my-2 list-decimal">
          <li>
            <Typography className="mb-2 font-16">
                Provide feedback to advertising partners that one of their visitors also visited the Site</Typography>
          </li>
          <li>
            <Typography className="font-16">Provide our advertisers with data relating to ads that have been displayed to you or that you have
                clicked on, and the date and time of your use
            </Typography>
          </li>
          <li>
            <Typography className="font-16">To show you relevant advertising off of the Site
            </Typography>
          </li>
          <li>
            <Typography className="font-16">To understand what actions you take on the Site after receiving our advertising
            </Typography>
          </li>
        </ol>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">Third-Party Cookies </b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">We work with analytics service providers, advertising partners, and advertising networks that may have access to
        your device information which is anonymous data. In other words, third parties do not collect information such
        as your name, contact details or other personal information.
        </Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">HOW CAN I CONTROL COOKIES?</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">You can amend or "opt out" of the collection of information created through cookies or other technology by
        actively managing the settings on your browser or mobile device. If you choose to reject cookies, your access to
        some functionality and areas of our Site may be restricted.
        </Typography>
        <Typography className="font-16">Our Site does not support Do Not Track settings (“DNT”) at this time. DNT is a privacy preference you can set in
        your web browser to indicate that you do not want certain information about your Site visits collected across
        Sites when you have not interacted with that service on a page. For more information about how to control
        cookies, please see “More About Cookies”.
        </Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">CHANGES AND UPDATES TO THE COOKIE POLICY</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">We may update this Cookie Policy from time to time in order to reflect, for example, changes to the cookies we
        use or for other operational, legal or regulatory reasons. Please therefore re-visit this Cookie Policy
        regularly to stay informed about our use of cookies and related technologies.
        </Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">QUESTIONS</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">If you have any questions about our use of cookies or other technologies, please email us at
        support@goodvets.com.
        </Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold font-16">MORE INFORMATION ABOUT ANALYTICS</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">Our Site uses Google Analytics, a web analysis service from Google Inc., 1600 Amphitheatre Parkway, Mountain
        View, CA 94043, USA ("Google"). Google Analytics uses cookies text files that are stored on your device and make
        it possible to analyze how you utilize the site. The information generated by the cookie (including the IP
        address) is transferred and stored on a Google server located in the United States.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">Google uses the information on our behalf to evaluate how the Site is used, create reports about the activities
        on the Site for the site operators, and to perform additional services regarding Site and internet utilization.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">Further you can prevent the collection and processing of cookies created data relating to your utilization of the
        Site (including your IP) via Google by downloading and installing the browser-plugin available under the
        following link tools.google.com/dlpage/gaoptout.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">You can refuse the use of Google Analytics by clicking on the following link. An opt-out cookie will be set on
        the device, which prevents the future collection of your data when visiting this Site; for more information on
        Google Analytics and Google’s privacy practices, please review their privacy policy at
        www.google.com/policies/privacy.
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">Further information concerning the terms and conditions of use and data privacy can be found at
        www.google.com/analytics/terms/gb.html or at www.google.de/intl/en_uk/policies.
        </Typography>
        <Typography><br/></Typography>
        <Typography><b className="font-semibold">MORE INFORMATION ABOUT COOKIES</b>
        </Typography>
        <Typography><br/></Typography>
        <Typography className="font-16">You can learn more about cookies at www.allaboutcookies.org, Network Advertising Initiative at
        www.networkadvertising.org, and YourAdChoices at optout.aboutads.info.
        </Typography>
        <Typography><br/></Typography>
      </Box>

      <Box sx={contentFooterStyle}>
        <img src="/assets/icons/logo_black.svg" className="mx-auto" alt="GoodVets" width={120} />

        <Box sx={{ py: 2 }}>
          <Typography variant="body1" sx={{ color: "#888", fontSize: "11px" }}>
            Website: www.goodvets.com
          </Typography>
          <Typography variant="body1" sx={{ color: "#888", fontSize: "11px" }}>
            Instagram: @good.vets
          </Typography>
          <Typography variant="body1" sx={{ color: "#888", fontSize: "11px" }}>
            Facebook: www.facebook.com/GoodVets
          </Typography>
        </Box>

      </Box>
    </>
  );
};

export default PrivacyContentPage;
